import { Modal } from 'components';
import PropTypes from 'prop-types';
import React from 'react';
import * as Ui from './ChoiceModal.styles';

const ChoiceModal = ({
  isOpen,
  onClose,
  title,
  options,
  onSelect,
  selectedId,
  contentStyle = { maxWidth: '520px' },
}) => (
  <Modal
    open={isOpen}
    wide
    contentStyle={contentStyle}
    bodyStyle={{ padding: 0 }}
    header={{ title }}
    closeOnDocumentClick
    onClose={onClose}
  >
    <Ui.ChoiceBody>
      {options.map(({ id, icon, title: optionTitle, description }) => (
        <Ui.ChoiceCard
          key={id}
          type="button"
          $selected={selectedId === id}
          onClick={() => onSelect(id)}
        >
          <Ui.ChoiceIcon>
            <i className={icon} aria-hidden="true" />
          </Ui.ChoiceIcon>
          <Ui.ChoiceInfo>
            <Ui.ChoiceTitle>{optionTitle}</Ui.ChoiceTitle>
            <Ui.ChoiceDesc>{description}</Ui.ChoiceDesc>
          </Ui.ChoiceInfo>
        </Ui.ChoiceCard>
      ))}
    </Ui.ChoiceBody>
  </Modal>
);

ChoiceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedId: PropTypes.string,
  contentStyle: PropTypes.object,
};

export default ChoiceModal;
